export default "__VITE_ASSET__CnZl_mPe__"